import {PRESET_RESAMPLED} from './LinkTypes.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash';

export default superclass => class extends superclass  {

    async presetResampled(originalHash, resampledHash) {
        await this.newLinks(
            PRESET_RESAMPLED,
            ipfsHashToBytes32(originalHash),
            ipfsHashToBytes32(resampledHash));
    }

    async getResampledPreset(presetHash) {
        // look for any resamples
        let links = await this.getLinks(PRESET_RESAMPLED, presetHash);
        if (links.length === 0) {
            return undefined;
        }
        return links[0].toData;
    }
}
